import { useTranslation } from 'react-i18next';
import { FileItem, FileStatus } from '@sib/types';

export const useFileUploadItem = (fileItem: FileItem) => {
  const { t } = useTranslation();
  const isUploaded = fileItem.status === FileStatus.Uploaded;
  const isError = fileItem.status === FileStatus.Error;
  const isFileUploading = fileItem.status === FileStatus.Uploading;
  const isFileDownloadable = !!fileItem?.downloadUrl;

  const getUploadPhase = () => {
    if (fileItem.progress <= 10) return t('fileManager.uploadPhases.preparing');
    if (fileItem.progress <= 90) return t('fileManager.uploadPhases.uploading');
    if (fileItem.progress < 100)
      return t('fileManager.uploadPhases.processing');

    return t('fileManager.uploadPhases.complete');
  };

  return {
    isUploaded,
    isError,
    isFileUploading,
    isFileDownloadable,
    getUploadPhase,
  };
};
